import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';
import { Message, MessageService } from 'primeng/api';
import { BehaviorSubject, Subscription } from 'rxjs';
import { STATUS } from '../../models/loading-status.enum';
import { environment } from '../../../../../environments/environment';
import { LoginMessages } from '../../../../../assets/data/login-messages';
import { gsisOAuth2FormConfig } from './gsis-oauth2.config';
import { GsisOAuth2Service } from '../../../../services/gsisOAuth2/gsisOAuth2.service';
import { IToken } from '../../models/token-response.model';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-gsis-oauth2',
  templateUrl: './gsis-oauth2.component.html',
  styleUrl: './gsis-oauth2.component.scss',
})
export class GsisOauth2Component {
  appTitle = environment.appTitle;
  appSubtitle = environment.appSubtitle;

  STATUS = STATUS;
  subscriptions: Subscription[] = [];
  today = format(new Date(), 'iiii dd/MM/yyyy', { locale: el });
  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
    window.location.href.indexOf('local') !== -1
      ? true
      : false;

  gsisOAuth2FormConfig = gsisOAuth2FormConfig;
  form = this.fB.group(gsisOAuth2FormConfig.getFormGroup());

  authForm: { afm: string };
  submitted = false;

  appVersion = environment.appVersion;

  afm = '';

  errorMessages: Message[] = [];

  status$ = this.gsisOAuth2Service.loginCallHandler.status$;
  token$ = this.authService.token$;

  loginError$ = this.gsisOAuth2Service.loginCallHandler.error$;

  alertMessage: Message[] = [];
  token: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly fB: FormBuilder, 
    private route: ActivatedRoute,
    private readonly gsisOAuth2Service: GsisOAuth2Service,
    private messageService: MessageService,
    private authService: AuthService
  ) {
    this.authForm = { afm: '' };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const refParam: string = params['ref'];
      this.setAlertMessage(refParam);
      //console.log('ref:', refParam);
    });
    this.token = this.route.snapshot.paramMap.get('token');
    this.subscribeToStoreEffects();
  }

  subscribeToStoreEffects(): void {
    this.subscriptions = [
      this.token$.subscribe((t) => {
        if (!t) return;
        this.router.navigate(['home']);
        setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
      })
    ];
  }

  setAlertMessage(refParam: string): void {
    switch (refParam) {
      case 're':
        this.messageService.add({
          severity: 'error',
          summary: 'Αποτυχία',
          detail: LoginMessages.REGISTERED.Message,
        });
        break;
      default:
        this.alertMessage = []; // Default alert message
        break;
    }
  }

  onSubmit(): void {
    this.errorMessages = [];
    let afm = this.form.get('afm')?.value ?? '';
    let amka = this.form.get('amka')?.value ?? '';
    this.gsisOAuth2Service.fetchToken(afm,amka, this.token ?? '').subscribe((data) => {
      this.setToken(data?.token);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  setToken(token: string) {
    localStorage.setItem('token', JSON.stringify(token));
    let decodedToken: IToken = jwtDecode(token);
    this.token$.next(decodedToken);
  }
}
